export default __webpack_public_path__ + "static/Rhyme10-eebbd64ecb13cb13cbc92fc224a5310a.mp3";